import { BoxEntity } from "@modules/box/entities/boxEntity"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { ProgramBoxSubscriberDetailsHeader } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programBoxSubscriberDetailsHeader"
import { ProgramSubscriberDetailsHeader } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsHeader"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import {
  useProgramSubscriberDetails,
  UseProgramSubscriberDetailsKey,
} from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"

type ProgramSubscriberDetailsLayoutProps = {
  program: UserProgramDetailsEntity | ProgramBundleEntity
  subscriberId: string
  isBoxSubscriber: boolean
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsHeaderWrapper({
  program,
  subscriberId,
  isBoxSubscriber,
}: ProgramSubscriberDetailsLayoutProps) {
  const { data: subscriberDetails } = useProgramSubscriberDetails(
    program instanceof ProgramBundleEntity
      ? UseProgramSubscriberDetailsKey.PROGRAM_BUNDLE_SUBSCRIBER
      : isBoxSubscriber
        ? UseProgramSubscriberDetailsKey.PROGRAM_BOX_SUBSCRIBER
        : UseProgramSubscriberDetailsKey.PROGRAM_SUBSCRIBER,
    program.id,
    subscriberId,
  )

  if (isBoxSubscriber && subscriberDetails instanceof ProgramSubscriberEntity && !!subscriberDetails.box)
    return (
      <ProgramBoxSubscriberDetailsHeader
        program={program}
        subscriberDetails={subscriberDetails as ProgramSubscriberEntity & { box: BoxEntity }}
      />
    )
  return <ProgramSubscriberDetailsHeader program={program} subscriberDetails={subscriberDetails} />
}
